/**
 * Core payment type definitions
 * Enums and flow parameter types used across the payment system
 */

import type { RegistrationPaymentInput } from '../../api/models/Registration';

export enum PaymentProviderType {
  AIRWALLEX = 'AIRWALLEX',
  SPREEDLY = 'SPREEDLY',
  ECPAY = 'ECPAY',
  OCTO = 'OCTO',
}

/** Who authenticates the card (3-D Secure), independent of who holds it. */
export enum PaymentAuthenticationProviderType {
  TRIDENT_CARDINAL = 'TRIDENT_CARDINAL',
}

/** The card, named one way across the flow: who holds it and its opaque token. */
export interface PaymentMethodRef {
  provider: PaymentProviderType;
  token: string;
}

export enum PaymentContext {
  SUBSCRIPTION = 'subscription',
  BOOKING = 'booking',
  CHANGE_CARD = 'changeCard',
}

export interface SubscriptionFlowParams {
  tenantId: string;
  cardholderName: string;
}

export interface BookingFlowParams {
  tenantId: string;
  cardholderName: string;
  expiryMonth: string;
  expiryYear: string;
}

export interface ChangeCardFlowParams {
  tenantId: string;
  cardholderName: string;
  subscriberId: string;
  currency: string;
}

export type PaymentFlowResult = RegistrationPaymentInput;

export interface TokenizationInitResponse {
  providerData: {
    nonce: string;
    timestamp: number;
    certificateToken: string;
    signature: string;
  };
}

export interface TokenizePayload {
  fullName: string;
  month: string;
  year: string;
}
